import { useAtom } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import Radio from "@components/common/radio";
import { CounselDesignItemQuantity } from "./counsel-design-item-quantity";
import { CounselDesignItemTree } from "@feature/counsel/update/counsel-design-info";

type Props = {
  c2: CounselDesignItemTree;
  c3: CounselDesignItemTree;
};

const CounselDesignItemRadio = ({ c2, c3 }: Props) => {
  const [hCostResult, setHCostResult] = useAtom(hcostInboundAtom);

  const radioCheckHandler = (e: any, item: CounselDesignItemTree) => {
    if (!e) return;
    const data = hCostResult.counselDesigns[0].counselDesignItems.find(
      (v: CounselDesignItem) => v.itemNumber === e.target.value,
    );
    if (data.enabled) {
      setHCostResult(prev => {
        prev.counselDesigns[0].counselDesignItems.find(
          (v: CounselDesignItem) => v.itemNumber === e.target.value,
        ).enabled = false;
        prev.counselDesigns[0].counselDesignItems.find(v => v.itemNumber === item.parentItemNumber).enabled = false;
        prev.isCostSimpleFlag = true;
      });
    } else {
      setHCostResult(prev => {
        const preData = prev.counselDesigns[0].counselDesignItems
          .filter((c: CounselDesignItem) => c.category3.code === item.category3.code)
          .find((i: CounselDesignItem) => i.enabled && i.itemValue.code !== "000");
        if (preData) preData.enabled = false;
        prev.counselDesigns[0].counselDesignItems.find(
          (v: CounselDesignItem) => v.itemNumber === e.target.value,
        ).enabled = true;
        const parent = prev.counselDesigns[0].counselDesignItems.find(v => v.itemNumber === item.parentItemNumber);
        if (parent) {
          prev.counselDesigns[0].counselDesignItems.find(v => v.itemNumber === item.parentItemNumber).enabled = true;
          if (parent.parentItemNumber) {
            prev.counselDesigns[0].counselDesignItems.find(v => v.itemNumber === parent.parentItemNumber).enabled =
              true;
          }
        }
        prev.isCostSimpleFlag = true;
      });
    }
  };

  return (
    <>
      <div key={c3.itemNumber} className={`${c3.itemName === c2.itemName ? "" : "ml-7"}`}>
        <div className="mr-2 my-1">{c3.itemName === c2.itemName ? null : c3.itemName}</div>
        {/*items*/}
        <div className={`flex flex-wrap items-center gap-x-3 ${c3.itemName === c2.itemName ? "ml-4" : "ml-2"}`}>
          {c3?.children.map((i: CounselDesignItemTree) => (
            <Radio
              className={`ml-3.5 mr-2 mb-1 `}
              labelClassName="!text-sm"
              key={i.itemName}
              label={i.itemName}
              value={i.itemNumber}
              name={c3.itemNumber}
              onClick={e => radioCheckHandler(e, i)}
              checked={
                !!hCostResult.counselDesigns[0].counselDesignItems.find(v => v.itemNumber === i.itemNumber && v.enabled)
              }
              readOnly={true}
            />
          ))}
        </div>
        {/*수량*/}
        <CounselDesignItemQuantity data={c3} />
      </div>
    </>
  );
};

export default CounselDesignItemRadio;
